import React from 'react';

export default <div className="oneColorPause" style={{height: '100%'}}>
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 38 39">
    <g fill="#2B328C" fillRule="evenodd">
      <path d="M14.637 4.507c-.455-2.602-3.508-4.61-6.66-4.503-3.152.108-6.195 2.25-6.64 4.8-1.782 9.208-1.782 20.184 0 29.392.445 2.55 3.488 4.693 6.64 4.8 3.152.108 6.205-1.901 6.66-4.503 1.817-9.393 1.817-20.592 0-29.986M36.638 4.507c-.455-2.602-3.509-4.61-6.66-4.503-3.152.108-6.196 2.25-6.642 4.8-1.781 9.208-1.781 20.184 0 29.392.446 2.55 3.49 4.693 6.642 4.8 3.151.108 6.204-1.901 6.66-4.503 1.816-9.393 1.816-20.592 0-29.986"/>
    </g>
  </svg>
</div>;
